import React from "react";

const SuccessNotification = ({ successMsg }) => {
  return (
    <div className="success-notification">
      <span className="pi pi-check text-s ml-2 mr-2"></span>
      {successMsg}
    </div>
  );
};

export default SuccessNotification;
